import React from 'react';

/**
 * RTL-safe centered empty state row for Qawaem list tables.
 */
export default function QawaemTableEmptyRow({
  colSpan,
  icon: Icon,
  message,
  hint,
  iconClassName = 'h-12 w-12 text-white/30 mb-4',
  messageClassName = 'text-white/60',
  hintClassName = 'text-white/40 text-sm mt-1',
  cellClassName = '',
}) {
  return (
    <tr>
      <td colSpan={colSpan} className={`qawaem-table-empty-cell p-0 border-none ${cellClassName}`.trim()}>
        <div className="qawaem-table-empty-state">
          {Icon ? <Icon className={iconClassName} aria-hidden /> : null}
          {message ? <p className={`qawaem-table-empty-state__message ${messageClassName}`.trim()}>{message}</p> : null}
          {hint ? <p className={`qawaem-table-empty-state__hint ${hintClassName}`.trim()}>{hint}</p> : null}
        </div>
      </td>
    </tr>
  );
}
